<template>
	<div class="row container-fluid px-0 d-flex justify-content-center">
    	<br>
    	<h1 class="page-title letraDelTitulo col-12">VERIFICACIÓN DE PAGOS</h1>
    	<div class="col-6 padding-div-low ">
    		<div class="area-claro">	
    			<div class="form-group">
             		<label for="codigoVerificacion">Ingrese código de verificación</label>
             		<input id="codigoVerificacion" v-model="qr" class="form-control form-control-claro" placeholder="Código de Verificación" autocomplete="off"/>
        		</div>
              	<div class="text-right">
                	<button class="btn btn-primary overwrapDeBotones btn-buscar" id="buscarPagos" @click="buscarPagos()"><i class="fa fa-search"></i>&nbsp;&nbsp;</button>
              	</div>
    		</div>
    	</div>
        <div  v-if="Pagos" class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low">
        	<div class="area-claro">
        		<h2>Pago Encontrado</h2>
        		<table style="width: 100%" class="table">
              		<tr><td>FECHA EN QUE SE REGISTRÓ EL PAGO: </td><td class="Recibo">{{FechaAPalabras(Recibo.FechaDePago)}}</td></tr>
              		<tr><td>JUZGADO: </td><td class="Recibo">{{Recibo.Expediente.Area.Nombre}}</td></tr>
              		<tr><td>{{Recibo.Expediente.TipoDocumento.Nombre  + ': '}} </td><td class="Recibo"> {{((Recibo.Expediente.NumeroRomano == null) ? Recibo.Expediente.Consecutivo : Recibo.Expediente.Consecutivo +"-"+ Recibo.Expediente.NumeroRomano)}}</td></tr><br>
              		<tr><td>NOMBRE: </td><td  class="Recibo"> {{ Imputado.Nombre +" "+
            			(Imputado.ApellidoPaterno == null ? "" : Imputado.ApellidoPaterno) +" "+ 
          				(Imputado.ApellidoMaterno == null ? "" : Imputado.ApellidoMaterno)}}</td></tr>
          			<tr><td></td></tr><br>
          			<tr><td>CONCEPTO(S)</td><td style=" text-align: right">IMPORTE POR CONCEPTO</td></tr><br>
          			<tr v-for="(rubro, indexR) in Pagos" style=""><td>{{rubro.RubroDBPJ.Nombre.toUpperCase()}}</td>
            			<td style="text-align: right">{{"$"+agregarCeros(rubro.Monto) }} </td></tr><br>
            		<tr><td>TOTAL</td><td style=" text-align: right">{{"$"+agregarCeros(total)}}</td></tr>
            		<tr><td colspan="2" style="text-align: right;">({{numerosAPalabras(total) + (total == 1 ? ' PESO' : ' PESOS') + ' ' +(total % 1).toFixed(2).substring(2) + '/100 M.N.'}})</td></tr>
            	</table>
        	</div>
        </div>
	</div>
</template>
<script>
	import enumeraciones from '@/../static/js/enumeraciones'
  	import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  	import catalogos from '@/../static/js/catalogos'
  	import api from '@/../static/js/api'
  	import comun from '@/../static/js/comun'
  	import axios from 'axios'
  	import func from '../../../SIVAC/Comun/Funciones/comun.js'

	export default{
		data(){
			return{
				enumeraciones,
        		enumeraciones_sicpo,
        		nombreDeVariableDelComponente: "cargoPaginaOficial",
       	 		qr: "",
       	 		Pagos:null,
        		Imputado: null,
        		Recibo: {
          			Expediente:{
            		Area:{},
            		TipoDocumento:{}
          			},
          			FechaDePago:String,
          			Hash: ""
        		},
			}
		}, 

		computed: {
      		total(){//ir sumando cada monto
        		if(this.Pagos){
          			return this.Pagos.reduce((sum, Pagos)=>{
            			return sum + Pagos.Monto
          			}, 0)
        		}
      		}
    	},   

		mounted() {
      		this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
      	},

      	methods: {
      		buscarPagos:function(){
      			const parametros = 
        		{    
          			Hash: this.qr                          
        		}

        		if(this.validarDatosBusqueda(parametros)){
					const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);   

        			var conexion = api.conexion + api.SIVAC.sistema.caja.pagos.BuscarPagosQR

        			axios.post(conexion, parametros, headerPeticion)
          			.then(respuesta => {
            			if (respuesta.data.SiHayError) {
              				console.log(respuesta);
                			comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        } else {
              				this.Imputado = respuesta.data.Pagos[0].Persona;
              				this.Recibo = respuesta.data.Pagos[0];
              				this.Pagos = respuesta.data.Pagos;
              				//     this.index += 1; por si falla al recargar descomentar
              				//console.log(this)
            			}
          			})
          			.catch(e => {
            			comun.SeEstaCargandoInformacion(false);
            			console.log("No Hay Respuesta del Servidor" + e);
            			comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          			});

        		}

        		
      		},
      		FechaAPalabras: function(fecha){
          		return func.FechaAPalabras(fecha)
      		},
      		agregarCeros : function(monto){
          		return func.agregarCeros(monto)
      		},
      		numerosAPalabras: function(numero){
          		return func.numerosAPalabras(numero)
      		},
      		validarDatosBusqueda: function(datos){
      			if(datos.Hash == null || datos.Hash == undefined || datos.Hash == ''){
      				comun.mensajeDeAlerta("Favor de ingresar el código de verificación que viene en su recibo", null, null);
          			return false;
      			}
      			return true;
      		}
    	}
	}
</script>
<style scoped>
	.page-title {
    	background-color: rgb(0,117,115);
    	color: #FFF;
    	padding: 2vh 20vw;
  	}
  	.btn-buscar{
    background-color: var(--gris-pj);
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/VerificacionDePagos/BusquedaVerificacionPagos.vue